// extracted by mini-css-extract-plugin
export default {"tab_all":"index_tab_all_qg0lV clearfix","tabs_box":"index_tabs_box_YNPGq","tab_box":"index_tab_box_cuHZZ"};